export default __webpack_public_path__ + "static/media/BB_32.9d74ae22.png";